









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'
import {InputMotoristaMensagemPushSchema} from '@/schema/resource/MotoristaMensagemPush/InputMotoristaMensagemPushSchema'

@Component
export default class PersistMotoristaMensagemPushView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMotoristaMensagemPushSchema()
  motoristaMensagemPush = new MotoristaMensagemPush()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionMotorista.listMotorista()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.motoristaMensagemPush.getMotoristaMensagemPush(id)
    }

    $.await.done('getMotoristaMensagemPush')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.motoristaMensagemPush.persistMotoristaMensagemPush()
    await Helper.successAndPush(
      'system.success.persist',
      '/motorista-mensagem-push/list'
    )
  }
}
